import './RnD.css'

const RnD = () => {
  return (
    <div className="rnd-page">
      {/* Hero Section */}
      <section className="rnd-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1>NEXPA R&amp;D 사업혁신본부</h1>
            <p className="hero-subtitle">Government Project &amp; AI Solution Division</p>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="rnd-intro">
        <div className="container">
          <div className="intro-content">
            <p className="intro-quote">
              "기획부터 데이터, AI까지 — IT 프로젝트의 성공을 설계합니다."
            </p>
            <p className="intro-desc">
              NEXPA R&amp;D 사업혁신본부는 AI 기반 문해력 평가 플랫폼 개발과 산업·정책 콘텐츠 기획을 통해
              축적한 기술력과 프로젝트 수행 역량을 바탕으로, 공공·정부 지원사업과 기업 IT 프로젝트의
              전 과정을 통합 지원하는 전문 부서입니다. 복잡한 정책 과제와 비즈니스 요구를
              실행 가능한 통합솔루션으로 전환하는 것을 핵심 미션으로 합니다.
            </p>
          </div>
        </div>
      </section>

      {/* 주요 업무 영역 */}
      <section className="rnd-services">
        <div className="container">
          <h2 className="section-title">주요 업무 영역</h2>
          <div className="services-list">

            <div className="service-item card">
              <div className="service-number">01</div>
              <div className="service-body">
                <h3>정부지원사업 IT개발 서포트</h3>
                <p>
                  정부·공공기관 및 기업이 수행하는 R&amp;D 및 디지털 전환 과제의 시스템 설계와
                  개발을 지원합니다. 플랫폼 구축, 시스템 고도화, 시제품·실증(PoC) 개발까지
                  사업 목표에 맞춘 기술 실행을 책임집니다.
                </p>
              </div>
            </div>

            <div className="service-item card">
              <div className="service-number">02</div>
              <div className="service-body">
                <h3>SI 및 외주개발 <span className="service-sub">System Integration &amp; Outsourcing</span></h3>
                <p>
                  기업과 기관의 요구에 맞춰 시스템 통합(SI)과 맞춤형 외주개발을 수행합니다.
                  웹·모바일 애플리케이션, 업무 시스템, 플랫폼 구축 등 다양한 프로젝트를
                  요구사항 분석부터 설계, 개발, 운영·유지보수까지 전 주기로 대응합니다.
                  고객의 환경과 예산에 맞는 유연한 협업 모델을 제공합니다.
                </p>
              </div>
            </div>

            <div className="service-item card">
              <div className="service-number">03</div>
              <div className="service-body">
                <h3>연구기획 <span className="service-sub">Research Planning</span></h3>
                <p>
                  사업의 출발점인 기획 단계부터 함께합니다. 과제 발굴과 정책 분석,
                  사업계획서 및 제안서 설계, 기술 로드맵 수립을 통해 선정 가능성과
                  실행 완성도를 동시에 높입니다. 산업·정책 콘텐츠를 다뤄온 경험을 바탕으로
                  복잡한 과제를 명확한 메시지와 논리로 구조화합니다.
                </p>
              </div>
            </div>

            <div className="service-item card">
              <div className="service-number">04</div>
              <div className="service-body">
                <h3>데이터 가공 <span className="service-sub">Data Processing</span></h3>
                <p>
                  AI 학습과 정책 의사결정의 기반이 되는 데이터를 수집·정제·라벨링·구조화합니다.
                  비정형 데이터의 표준화, 학습용 데이터셋 구축, 품질 검증을 통해
                  신뢰할 수 있는 데이터 자산을 설계합니다.
                </p>
              </div>
            </div>

            <div className="service-item card">
              <div className="service-number">05</div>
              <div className="service-body">
                <h3>AI 접목 사업 <span className="service-sub">AI Integration</span></h3>
                <p>
                  기존 서비스와 공공 업무에 AI 기술을 결합해 새로운 가치를 만듭니다.
                  AI 기반 진단·분석·자동화 모델 적용, 맞춤형 AI 솔루션 개발 등
                  NEXPA의 핵심 AI 역량(문항 자동 생성, 평가·피드백 엔진 등)을
                  다양한 산업 영역으로 확장합니다.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 차별점 */}
      <section className="rnd-diff">
        <div className="container">
          <h2 className="section-title">NEXPA TEAM의 차별점</h2>
          <div className="diff-content card">
            <ul className="diff-list">
              <li>기획–개발–데이터–AI를 잇는 원스톱 수행 체계로 분절 없는 사업 실행이 가능합니다.</li>
              <li>SI·외주개발부터 AI 고도화까지 단순 구축형 프로젝트와 첨단 AI 프로젝트를 모두 소화하는 폭넓은 기술 스펙트럼을 갖추고 있습니다.</li>
              <li>정책·공공 프로젝트 이해도를 바탕으로 기술과 행정 요건을 동시에 충족시킵니다.</li>
              <li>검증된 AI 플랫폼(LIDIA) 개발 경험을 다른 영역에 적용 가능한 확장성을 갖추고 있습니다.</li>
              <li>단발성 결과물이 아닌, 장기 활용 가능한 데이터·기술 자산화를 지향합니다.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="rnd-cta">
        <div className="container">
          <div className="cta-content card">
            <p className="cta-lead">
              정부지원사업 기획부터 SI·외주개발, AI 구현까지
            </p>
            <h2>NEXPA R&amp;D 사업혁신본부가 함께합니다.</h2>
          </div>
        </div>
      </section>
    </div>
  )
}

export default RnD
